import type {
  Configuration,
  CreateDlsgPolicyRequest,
  UpdateDlsgPolicyRequest,
} from '@repo/api-gw-sdk';
import { DlsgPoliciesApi } from '@repo/api-gw-sdk';

import type { HttpClient } from './httpClient';

const baseUrl = '/storage-gateway';

export const storageGateway = (
  httpClient: HttpClient,
  config: Configuration,
  currentProjectId: string
) => {
  const dlsgPoliciesApi = new DlsgPoliciesApi(config);

  return {
    listPolicies: () =>
      httpClient.execute(
        dlsgPoliciesApi.listDlsgPolicies.bind(dlsgPoliciesApi),
        baseUrl,
        'listDlsgPolicies',
        currentProjectId
      ),
    create: (request: CreateDlsgPolicyRequest) =>
      dlsgPoliciesApi.createDlsgPolicy(currentProjectId, request),
    update: (id: string, request: UpdateDlsgPolicyRequest) =>
      dlsgPoliciesApi.updateDlsgPolicy(id, currentProjectId, request),
  };
};
